import AssessmentApiCall from 'ASSESSMENT/AssessmentApiCall';
import SuccessModal from 'ASSESSMENT/CommonResources/SuccessModal/SuccessModal';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import 'ASSESSMENT/Components/ResultList/resultlist.css';
import Spinner from 'ASSESSMENT/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import ResultDetails from './ResultDetails/ResultDetails';

class ResultList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isResultFetching: false,
            resultList: [],
            sortedIdArray: [],
            instituteName: '',
            instituteLogo: '',
            instituteId: '',
            pageIndex: 1,
            limit: 10,
            total: 0,
            offset: 0,
            filterAcademicYear: '',
            filterDepartment: '',
            academicYearList: {},
            sortedAcaYrArray: [],
            departmentList: {},
            sortedDepartmentArray: [],
            instituteUrl: this.props.match.params.instituteUrl,
            isValidUrl: '',

            // VARIABLES TO VIEW RESULT
            viewResult: false,
            uniqueResultId: '',
            resultTitle: '',
            customColumnConfiguration: [],
            averageGradePointTitle: '',
            gradePointLabels: {},

            // VARIABLES FOR SUCCESS MODAL
            successModal: false, 
            successModalType:'',
            successMessage:''
        };
    }

    componentDidMount () {
        // METHOD CALLED TO GET INSTITUTE DETAILS
        this.apiCallToGetInstituteDetails();

        // METHOD CALLED TO GET ACADEMIC YEAR LIST
        this.apiCallToGetAcademicYearList();

        // METHOD CALLED TO MAKE API CALL TO GET RESULT LIST
        this.apiCallToGetResultList();
    }

    // API CALL METHOD TO GET INSTITUTE DETAILS
    apiCallToGetInstituteDetails = async () => {
        let requestData = {
            "url": this.state.instituteUrl,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'getInstituteDataByURL',
            requestData,
            '/api/assessment/assessmentLogin/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails();
            }, 1000);
        } else {
            if (jsonResponse.success && jsonResponse.APIResult.success == 'true') {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    instituteId: apiResult.InstituteId
                }, () => {
                    this.apiCallToGetInstituteStreams();
                });
            }
        }
    }

    // API CALL METHOD TO GET ACADEMIC YEAR FILTER LIST
    apiCallToGetAcademicYearList = async () => {
        let requestData = {
            "url": this.state.instituteUrl,
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'GetAcademicYearListObject',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    academicYearList: apiResult || {},
                    sortedAcaYrArray: jsonResponse.APIResult.sortedIdArray || []
                });
            }
        }
    }

    // API CALL METHOD TO GET ACADEMIC BRANCH FILTER LIST
    apiCallToGetInstituteStreams = async () => {
        if (this.state.instituteId == '') {
            return;
        }

        let requestData = {
            "iid": this.state.instituteId,
            "delete_status": "active",
            "showParentGroupData": false
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreams();
            }, 1000);
        } else {
            if (jsonResponse.success && jsonResponse.APIResult.success == 'true') {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    departmentList: apiResult || {},
                    sortedDepartmentArray: Object.keys(apiResult || {})
                });
            }
        }
    }

    // API CALL METHOD TO GET RESULT LIST
    apiCallToGetResultList = async () => {
        this.setState({
            isResultFetching: true
        });

        let requestData = {
            "institute_url": this.state.instituteUrl,
            "aca_yr": this.state.filterAcademicYear,
            "sid": this.state.filterDepartment,
            "page_index": this.state.pageIndex,
            "limit": this.state.limit
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'getResultListForPublicPage',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetResultList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    instituteLogo: apiResult.InstituteLogo,
                    instituteName: apiResult.InstituteName,
                    resultList: apiResult.resultList,
                    sortedIdArray: jsonResponse.APIResult.sortedIdArray,
                    isResultFetching: false,
                    total: jsonResponse.APIResult.totalCount,
                    gradePointLabels: jsonResponse.APIResult.gradePointLabels || {},
                    isValidUrl: jsonResponse.APIResult.isValidUrl == 'true' ? true : false
                });
                document.content = ReactHtmlParser(apiResult.InstituteName);
            } else {
                this.setState({
                    isResultFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting institute result list. Please try again later.'
                });
            }
        }
    }
    
    // METHOD TO UPDATE PAGINATION COUNT
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit
        }, () => {
            this.apiCallToGetResultList();
        });
    }

    // METHOD TO HANDLE ACADEMIC YEAR FILTER CHANGE
    handleAcademicYearFilter = (e) => {
        this.setState({
            filterAcademicYear: e.target.value,
            pageIndex: 1,
            offset: 0
        }, () => {
            this.apiCallToGetResultList();
        });
    }

    // METHOD TO HANDLE ACADEMIC BRANCH FILTER CHANGE
    handleDepartmentFilter = (e) => {
        this.setState({
            filterDepartment: e.target.value,
            pageIndex: 1,
            offset: 0
        }, () => {
            this.apiCallToGetResultList();
        });
    }

    // METHOD TO CLOSE VIEW RESULT
    closeViewResult = () => {
        this.setState({
            viewResult: false
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        return(
            <>
                {
                    this.state.isValidUrl ?
                        <>
                            <div className="componentContainer">
                                {
                                    this.state.viewResult ?
                                        <ResultDetails
                                            resultId={this.state.uniqueResultId}
                                            resultTitle={this.state.resultTitle}
                                            customColumnConfiguration={this.state.customColumnConfiguration}
                                            averageGradePointTitle={this.state.averageGradePointTitle}
                                            gradePointLabels={this.state.gradePointLabels}
                                            instituteUrl={this.state.instituteUrl}
                                            instituteLogo={this.state.instituteLogo}
                                            instituteName={this.state.instituteName}
                                            closeViewResult={this.closeViewResult}
                                        />
                                    :
                                    this.state.isResultFetching ?
                                        <Spinner />
                                    :
                                        <>
                                            <div className="collegeInfo col-md-12">
                                                <div className="college-logo">
                                                    <img className="collegeLogo" src={this.state.instituteLogo} alt="institute-logo" />
                                                </div>
                                                <div className="college-name">
                                                    <h3>{ReactHtmlParser(this.state.instituteName)}</h3>
                                                </div>
                                            </div>
                                            <div className="result-filter-container">
                                                <div className="result-filter-field">
                                                    <label style={{ fontWeight: 'bold' }}>Academic Year</label>
                                                    <select className="form-control" value={this.state.filterAcademicYear} onChange={(e) => this.handleAcademicYearFilter(e)}>
                                                        <option value="">All Academic Years</option>
                                                        {
                                                            this.state.sortedAcaYrArray.map((yearId) => {
                                                                let yearData = this.state.academicYearList[yearId];
                                                                return (
                                                                    <option value={yearId} key={yearId}>{yearData.year_text}</option>
                                                                );
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="result-filter-field">
                                                    <label style={{ fontWeight: 'bold' }}>Academic Branch</label>
                                                    <select className="form-control" value={this.state.filterDepartment} onChange={(e) => this.handleDepartmentFilter(e)}>
                                                        <option value="">All Academic Branches</option>
                                                        {
                                                            this.state.sortedDepartmentArray.map((departmentId) => {
                                                                let departmentData = this.state.departmentList[departmentId];
                                                                return (
                                                                    <option value={departmentId} key={departmentId}>{departmentData.stream_name}</option>
                                                                );
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="resultList">
                                                <div className="resultTable col-md-10">
                                                    <table className="table table-bordered table-responsive-sm">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ padding: 10 }}>Sr. No.</th>
                                                                <th style={{ padding: 10 }}>Result</th>
                                                                <th style={{ padding: 10 }}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                Object.keys(this.state.resultList).length > 0 ?
                                                                    this.state.sortedIdArray.map((resultId, index) => {
                                                                        let result = this.state.resultList[resultId];
                                                                        return(
                                                                            <tr key={result.uniqueId}>
                                                                                <td style={{ padding: 10 }}>{this.state.offset + index + 1}.</td>
                                                                                <td className="resultTitle" style={{ padding: 10 }}>{result.title}</td>
                                                                                <td style={{ padding: 10 }}><span style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }} title='Click to view result' onClick={() => this.setState({ uniqueResultId: result.uniqueId, viewResult: true, resultTitle: result.title, customColumnConfiguration: result.customColumnConfiguration, averageGradePointTitle: result.averageGradePointTitle })}>View Result</span></td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                :
                                                                    <tr>
                                                                        <td colSpan="3">No results yet published for the institute.</td>
                                                                    </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {
                                                Object.keys(this.state.resultList).length > 0 &&
                                                <div id="paginationContainer">
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.total}
                                                        pageRangeDisplayed={3}
                                                        onChange={(num) => this.updatePaginationCount(num)}
                                                    />
                                                </div>
                                            } 
                                        </>
                                }
                            </div>
                            {
                                this.state.successModal &&
                                    <SuccessModal 
                                        successModal={this.state.successModal} 
                                        successModalType={this.state.successModalType}
                                        successMessage={this.state.successMessage}
                                        closeSuccessModal={this.closeSuccessModal} 
                                    />
                            }
                        </>
                    :
                        <div className="invalid-url">
                            <p>Invalid URL.</p>
                        </div>
                }
            </>
        );
    }
}

export default ResultList;
